function openMenu(){
    document.querySelector(".sidebar").classList.add("open");
}
function closeMenu(){
    document.querySelector(".sidebar").classList.remove("open");
}